import { render, staticRenderFns } from "./HeaderBlock.vue?vue&type=template&id=142e5527&scoped=true&"
import script from "./HeaderBlock.vue?vue&type=script&lang=js&"
export * from "./HeaderBlock.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBlock.vue?vue&type=style&index=0&id=142e5527&lang=scss&"
import style1 from "./HeaderBlock.vue?vue&type=style&index=1&id=142e5527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142e5527",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('142e5527')) {
      api.createRecord('142e5527', component.options)
    } else {
      api.reload('142e5527', component.options)
    }
    module.hot.accept("./HeaderBlock.vue?vue&type=template&id=142e5527&scoped=true&", function () {
      api.rerender('142e5527', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/header/HeaderBlock.vue"
export default component.exports